export default __webpack_public_path__ + "static/media/permit2.a794a9bc.png";